module.exports = __webpack_public_path__ + "static/media/enterprise_new_contact.1f7d7e24.png";